import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loginUser } from "../../redux/actions/authActions";
import { Link } from 'react-router-dom';
import LoginForm  from "./LoginForm"
import Spinner from "../common/Spinner";



function LoginPage({
    auth,
    loginUser,
    groupInvitation,
    history, 
    ...props
}) {

    const [user, setUser] = useState({ ...props.user });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [returnUrl, setReturnUrl] = useState(null);

    useEffect(() => {
        if (eval(auth.isAuthenticated)) {
            history.push("/dashboard");
        }
        if (props.location.search && props.location.search.startsWith("?rtn=")) {
            var rtn = props.location.search.split("&")[0].split("=")[1];
            setReturnUrl(rtn);
        }
        document.title = "Log in | JustGoRide";
    }, []);

    function handleChange(event) {
        const { name, value } = event.target;
        setUser(prevUser => ({
            ...prevUser,
            [name]: value
        }));
    }

    function formIsValid() {
        const { username, password } = user;
        const errors = {};

        if (!username) errors.username = "Username or Email is required.";
        if (!password) errors.password = "Password is required.";

        setErrors(errors);

        //Form is valid if the errors object still has no properties
        return Object.keys(errors).length === 0;
    }

    function handleLogin(event) {
        event.preventDefault();
        setProcessing(true);
        const creds = { username: user.username.trim(), password: user.password.trim() }
        if (groupInvitation.code) {
            creds.groupInvitation = groupInvitation;
        }

        if (!formIsValid()) {
            setProcessing(false);
            return;
        } 
        setProcessing(true);
        loginUser(creds).then((auth) => {

            if (!auth.isAuthenticated && auth.message) {
                alert(auth.message);
                return;
            }

            history.push(returnUrl ? returnUrl : "/dashboard");
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onProcessingLogin: error.message });
        });
    }

    return (
        processing ?
            <Spinner message={"Logging in..."} /> :
            <div className="row">
                <div className="jgr-login col-12 col-sm-8">
                    <LoginForm
                            user={user}
                            errors={errors}
                            onChange={handleChange}
                            onLogin={handleLogin}
                            processing={processing}
                            showTitle={false}
                    />
                    <div className="">
                        <Link to={"/forgotten"}>Forgotten something?</Link>
                    </div>
                </div>
               
                <div className="alt-login col-12 col-sm-4">
                    <div className="sign-up">
                        Not a member? <Link to={"/signup"}>Sign up now!</Link>
                    </div>
                </div>
            </div>
    );
}

LoginPage.propTypes =
{
        returnUrl: PropTypes.string,
        user: PropTypes.object.isRequired,
        auth: PropTypes.object.isRequired,
        groupInvitation: PropTypes.object.isRequired,
        errorMessage: PropTypes.string,
        loginUser: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {  
        user: { username: "", password: "" },
        auth: state.auth,
        groupInvitation: state.groupInvitation
    };
}

const mapDispatchToProps = {
    loginUser
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage); 


// WEBPACK FOOTER //
// ./src/components/user/LoginPage.js